import textHelper from '@utils/textHelper';
import { topologyLevels } from '@constants/index';

export class Topology {
  constructor(topology) {
    // Let's keep these as common keys for all the models
    /* Common Keys */
    this.uid = topology.uid;
    this.name = topology.name;
    this.permalink = topology.permalink;
    this.relativeLink = topology.relative_link;
    /* Common Keys */
    this.goalSlug = topology.slug;
    this.title = topology.title;
    this.coursesCount =
      topology.courses_count ||
      topology.item_count ||
      topology.count ||
      topology.plus_course_count ||
      topology.course_count ||
      0;
    this.upcomingCoursesCount = topology.upcoming_count || 0;
    this.upcomingCoursesThisMonth = topology.upcoming_this_month || 0;
    this.enrolledCoursesCount = topology.enrolled_count || 0;
    this.progress = topology.progress || 0;
    this.color = topology.color;
    this.plusCourseCount =
      topology.plusCourseCount || topology.total_count || 0;
    this.colorCode = topology.color_code;
    this.level = topology.level;
    this.fullName = topology.title;
    this.icon = topology.icon;
    this.children = topology.children;
    this.slug =
      topology.slug || textHelper.getStringWordsJoinedWith(topology.name, '-');
    this.parent = topology.parent;
    this.isPracticeAvailable = topology.is_practice_session;
    this.isPlusAvailable = topology.is_plus_available;
    this.isFreeUnavailable = topology.is_free_unavailable;
    this.language = topology.language || null;
    this.ogImage = topology.og_image || null;
    // window map
    // "today": 0,
    // "tomorrow": 1,
    // "this week": 2,
    // "in 15 days": 3,
    // "yesterday": -1,
    // "last week": -2,
    // "15 days ago": -3,
    this.window = topology.window;
    this.windowCount = topology.window_count;
    this.selfDataFetched = topology.selfDataFetched || false;
    this.tags = topology.tags;
    this.isNoTestGoal = !!topology.tags?.find(
      (tag) => tag?.name === 'NON_TEST_PREP'
    );
    this.isIconicAvailable = topology.is_iconic_available;
    this.externalApps = topology.external_apps_available;
    this.goalLevelOnboarding = {
      isAvailable: topology.is_goal_onboarding_available || false,
      status: topology.user_onboarding_status || null,
      hideNudge: false
    };
    this.isLeaderdboardMetaInfoAvailable =
      topology.is_leaderdboard_meta_info_available;
    this.leaderboardFilters = topology.leaderboard_filters;
    this.leaderboardScreenMetaInfo = topology.leaderboard_screen_meta_info;
  }
}

export const getEntityData = (data) => {
  const topology = new Topology(data);
  return topology;
};

export const getLink = (data) => {
  return `/goal/${data.slug}/${data.uid}`;
};

export const getLinkHref = () => '/goal/[goalSlug]/[goalUID]';

export const getTopicLink = (topic, goal) =>
  `/goal/${goal.slug}/${goal.uid}/topic/${topic.uid}`;

export const getTopicLinkHref = () =>
  '/goal/[goalSlug]/[goalUID]/topic/[topicUid]';

export const getTopicListLink = (goal) =>
  `/goal/${goal.slug}/${goal.uid}/topics`;

export const getTopicListHref = () => '/goal/goalSlug/goalUID/topics';

export const getLinkPath = () => '/goal/[goalSlug]/[goalUID]/topic/[topicUid]';

export const getSpecialClassesLink = (data) => `${getLink(data)}/classes`;

export const getSpecialClassesLinkHref = () => `${getLinkHref()}/classes`;

export const getSpecialClassesAllLink = (data) => ({
  href: '/goal/[goalSlug]/[goalUID]/classes',
  as: `${getLink(data)}/classes`
});

export const getHrefAndAsOfAFreeCourse = (data) => ({
  href: '/goal/[goalSlug]/[goalUID]/free-platform',
  as: `${getLink(data)}/free-platform`
});

export const getHrefAndAsOfSaved = (goal) => ({
  href: `${getLinkHref()}/saved`,
  as: `${getLink(goal)}/saved`
});

export const getTopologyName = {
  [topologyLevels.CATEGORY]: 'Category',
  [topologyLevels.GOAL]: 'Goal',
  [topologyLevels.GROUP]: 'Topic Group',
  [topologyLevels.TOPIC]: 'Topic',
  [topologyLevels.CONCEPT]: 'Concept',
  [topologyLevels.SUBCONCEPT]: 'Subconcept'
};

export default {
  Topology,
  getEntityData,
  getLink,
  getLinkHref,
  getSpecialClassesLink,
  getLinkPath,
  getTopicLink,
  getTopicListLink,
  getSpecialClassesAllLink,
  getHrefAndAsOfAFreeCourse,
  getTopicListHref,
  getSpecialClassesLinkHref,
  getTopicLinkHref,
  getHrefAndAsOfSaved,
  getTopologyName
};
